import { render, staticRenderFns } from "./showMemo.vue?vue&type=template&id=35743bca&scoped=true"
import script from "./showMemo.vue?vue&type=script&lang=js"
export * from "./showMemo.vue?vue&type=script&lang=js"
import style0 from "./showMemo.vue?vue&type=style&index=0&id=35743bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35743bca",
  null
  
)

export default component.exports